import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TemplateManagerService } from "src/app/services/template-manager.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Clipboard } from "@angular/cdk/clipboard";
import { updateShipmentDiscrepancy } from "src/app/models/shipmentMonitor.model";
import { ShipmentMonitorService } from "src/app/services/shipment-monitor.service";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-open-case-template",
  templateUrl: "./open-case-template.component.html",
  styleUrls: ["./open-case-template.component.scss"],
})
export class OpenCaseTemplateComponent implements OnInit,AfterViewInit,OnDestroy {
  selectedTemplate: any;
  templates:any[] = [];
  selectedRow:any;
  textAreaForm = new FormControl();
  form: FormGroup = new FormGroup({
    caseLink: new FormControl("", Validators.required),
    note: new FormControl(),
  });
  link = "https://sellercentral.amazon.com/help/center";
  isEdit: boolean = false;
  textArea: HTMLTextAreaElement;
  regex = /\[(.*?)\]/g;
  @ViewChild("textArea") _textArea: ElementRef;
  storeTemplateVar:any[]=[];
  isCaseLink:boolean=false;
  private destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<OpenCaseTemplateComponent>,
    private snackBar: MatSnackBar,
    private TemplateManagerService: TemplateManagerService,
    private clipboard: Clipboard,
    private shipmentMonitorService: ShipmentMonitorService,
    private router:Router
  ) {}

  ngAfterViewInit(): void {
    this.textArea = this._textArea?.nativeElement as HTMLTextAreaElement;
   }

  ngOnInit(): void {
    this.isCaseLink= this.data.isCaseLink;
    if(!this.data.params){
      this.getShipmentDiscrepancy();
    } else{
      this.selectedRow = this.data.params;
      this.getTemplate();
    }
    this.storeTemplateVar=this.TemplateManagerService.storeTemplateVar;
    this.textAreaForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
        this.selectedTemplate.templateText = res;
      }
    });
  }

  getShipmentDiscrepancy(){
    this.shipmentMonitorService.getShipmentDiscrepancy(this.data.shipmentDiscrepancyId).pipe(takeUntil(this.destroy$))
    .subscribe((res)=>{
      if(res){
        this.selectedRow = res;
        this.getTemplate();
      }
    })
  }

  action(event) {
    if (event == "Copy Text & Open Case") {  
      this.getTextFromHtml(this.selectedTemplate.formattedText);    
      this.isCaseLink = true;
      this.data.actions[1].text="Save";
      window.open(this.link);
    } else if (event == "Save") {
      this.updateStatus();
    } else {
      this.close();
    }
  }

  getTextFromHtml(htmlString: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    this.clipboard.copy(doc.body.textContent || '');
  }

  close() {
    this.dialogRef.close();
  }

  getTemplate() {
    this.TemplateManagerService.getTemplates().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if (res) {
          this.templates = res; 
          this.templates.forEach((res, i) => {
            if (res) {
              this.templates[i].templateText = this.TemplateManagerService.formatTempWithVarName(res.templateText);
            }
          });   
          this.setTemplateWithValue();      
        }
      },
     error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }

  setTemplateWithValue(){
    const defaultTemplate = this.templates.filter((res) => res.isDefault);
    this.selectedTemplate = defaultTemplate.length > 0 ? defaultTemplate[0] : this.templates[0];
    this.selectedTemplate = defaultTemplate.length > 0 ? defaultTemplate[0] : this.selectedTemplate;
    this.selectedTemplate.formattedText = this.TemplateManagerService.formatVarNameWithValues(this.selectedRow,this.selectedTemplate.templateText)
  }

  edit() {
    this.isEdit = !this.isEdit;
    this.textAreaForm.setValue(this.selectedTemplate?.templateText);
  }

  copyText() {
    this.selectedTemplate.formattedText = this.TemplateManagerService.formatVarNameWithValues(this.selectedRow,this._textArea.nativeElement.value)
    if (!this.selectedTemplate.templateText) {
      this.data.actions[1].isDisabled = true;
    } else {
      this.data.actions[1].isDisabled = false;
    }
    this.isEdit = false;
  }

  selectTemplate(item) {
    var text;
    this.textArea = this._textArea?.nativeElement as HTMLTextAreaElement;
    if (this.textArea?.value) {
      var start = this.textArea.selectionStart;
      var end = this.textArea.selectionEnd;
      text = this.textArea?.value.substring(0, start) + " " +`[${item.name}]` +" " + this.textArea?.value.substring(end);
      this.textAreaForm.setValue(text);     
    } else {
      text = this.selectedTemplate.templateText + `[${item.name}]`
      this.textAreaForm.setValue(text);
    }
    this.TemplateManagerService.setPosition(this.textArea,start,item);
  }

  updateStatus() {
    const paylaod: updateShipmentDiscrepancy = {
      shipmentDiscrepancyId: this.selectedRow.shipmentDiscrepancyId,
      isCaseCreated: true,
      caseStatusId: this.selectedRow.caseStatusId,
      caseLink: this.form.get("caseLink").value,
      note: this.form.get("note").value,
      refundedAmount: null,
    };
    this.shipmentMonitorService.updateShipmentDiscrepancy(paylaod).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        if (res) {
          this.dialogRef.close(
            {
              caseLink: this.form.get("caseLink").value,
              note: this.form.get("note").value,
              isCaseCreated:true
            }
          );
        }
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: "Status has been updated successfully",
            action: "Dismiss",
            type: "success",
          },
        });
      },
     error: (err) => {
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }

  onChange(event){
    let index = this.templates.findIndex((res)=> res.templateId == event.templateId);
    if(index !== -1){
      this.selectedTemplate = event;
    }
    this.selectedTemplate.templateText = this.TemplateManagerService.formatTempWithVarName(this.selectedTemplate.templateText);
    this.selectedTemplate.formattedText = this.TemplateManagerService.formatVarNameWithValues(this.selectedRow,this.selectedTemplate.templateText)
    this.textAreaForm.setValue(this.selectedTemplate.templateText);
  }

  navigate(){
    this.dialogRef.close();
    this.router.navigate(['/settings/system-settings']);
  }

  cancel(){
    this.isEdit = false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
